import { Directive } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { UnsavedChangesGuarder } from "../guards/unsaved-changes-guard";

@Directive()
export abstract class ChangeTracker implements UnsavedChangesGuarder {
  formGroup: FormGroup = new FormGroup({});

  abstract saveAndContinue(isUserLocked?: boolean): void;
}
